"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledSystem = require("styled-system");
var _templateObject;
var _excluded = ["bg", "label"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Chip = function Chip(_ref) {
  var _ref$bg = _ref.bg,
    bg = _ref$bg === void 0 ? 'primary' : _ref$bg,
    label = _ref.label,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledChip, _extends({
    bg: bg
  }, props), label);
};
var _default = Chip;
exports["default"] = _default;
var StyledChip = _styledComponents["default"].span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tpadding: 1px 4px;\n\t", "\n\tborder-radius: 10px;\n\tborder-bottom-right-radius: ", ";\n\tfont-weight: 600;\n\tcolor: ", ";\n\tline-height: 1.19;\n\tfont-size: 0.625rem;\n\ttext-align: center;\n\tcursor: pointer;\n\t", ";\n\t", "\n\t", "\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return "".concat(theme.mediaQueries.large, "{\n\t\tpadding: 5px 10px;\n\t\tfont-size : 1rem;\n\t}");
}, function (props) {
  return props.clipped && '0';
}, function (props) {
  return props.theme.colors.light;
}, _styledSystem.space, _styledSystem.layout, (0, _styledSystem.variant)({
  prop: 'bg',
  scale: 'backgrounds'
}));